var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBrush4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm1.34 15.36-1.35.15c-.74.08-1.37-.55-1.29-1.3l.15-1.36c.13-1.21 1.14-1.98 2.21-2 .1-.01.22 0 .33.01.47.06.92.28 1.3.65.37.37.58.81.64 1.26.01.11.02.22.02.32a2.26 2.26 0 0 1-2.01 2.27zm4.35-4.11a3.3 3.3 0 0 0-2.8-2.74c1.54-1.58 3.92-3.25 5.73-3.98.32-.12.64-.03.84.17.2.22.3.53.17.85-.72 1.8-2.37 4.16-3.94 5.7z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBrush4);
export default __webpack_public_path__ + "static/media/vuesax-bold-brush_4.001d5e84c56ecc9f6ab5357cdb34e3b2.svg";
export { ForwardRef as ReactComponent };